
import { Navigate } from "react-router-dom";

// Este componente se usa para proteger las rutas privadas
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  // Si no hay token → redirige al login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Si hay token → renderiza el contenido (children o rutas hijas)
  return children;
};

export default PrivateRoute;
